import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { PseTransactionService } from '../../../../services/recaudo/pse-transaction.service';
import { IGetPseTransactionDetalle } from '../../../../shared/interfaces/pse';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DEFAULT_DATE_FORMAT } from 'lib-base';

@Component({
  selector: 'app-detalle-transaccion-pse',
  standalone: true,
  imports: [CommonModule, DialogModule, SkeletonModule],
  templateUrl: './detalle-transaccion-pse.component.html',
  styleUrl: './detalle-transaccion-pse.component.scss'
})
export class DetalleTransaccionPSEComponent implements OnInit {

  showDialog: boolean = false;
  isLoading: boolean = false;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;

  cargarSkeletonImpuesto: boolean = false;
  cargarSkeletonEstado: boolean = false;

  trans: any = {};
  data !: IGetPseTransactionDetalle | null;

  constructor(
    private readonly _pts: PseTransactionService,
    private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividades: this._t.get('common.actividades'),
    }));
  }

  show(pago: number) {
    this.showDialog = true;
    this.getPseTransactionDetalle(pago);
  }

  hide() {
    this.showDialog = false;
  }

  //#region API Calls
  getPseTransactionDetalle(pago: number) {
    this.isLoading = true;
    this._pts.getPseTransactionDetalle(pago).subscribe({
      next: (data: IGetPseTransactionDetalle) => {
        this.data = data;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  //#endregion

}
